/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { Layout } from '@/data/types/Layout';

export const getResendActivationEmail = (): Layout => ({
	name: 'Aside',
	slots: {
		header: [{ name: 'Header', id: 'header' }],
		first: [{ name: 'ResendActivationEmail', id: 'resend-activation-email' }],
		footer: [{ name: 'Footer', id: 'footer' }],
	},
});
